import React from 'react';

import SearchTeaser from '../../../components/SearchTeaser';
import HomeDetail from './Detail';

const NodeHome = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'search_teaser':
      return <SearchTeaser entity={entity} />;
    case 'full':
    default:
      return <HomeDetail entity={entity} />;
  }
};

export default NodeHome;
